/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Opened_StateInputs */

const en_opened_state = /** @type {(inputs: Opened_StateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Opened`)
};

const ar_opened_state = /** @type {(inputs: Opened_StateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`مفتوح`)
};

const de_opened_state = /** @type {(inputs: Opened_StateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Geöffnet`)
};

const es_opened_state = /** @type {(inputs: Opened_StateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Abierto`)
};

const fr_opened_state = /** @type {(inputs: Opened_StateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ouvert`)
};

const it_opened_state = /** @type {(inputs: Opened_StateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aperto`)
};

const ja_opened_state = /** @type {(inputs: Opened_StateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`開封済み`)
};

const ko_opened_state = /** @type {(inputs: Opened_StateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`개봉됨`)
};

const pt_br_opened_state = /** @type {(inputs: Opened_StateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aberto`)
};

const ru_opened_state = /** @type {(inputs: Opened_StateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Открыто`)
};

const th_opened_state = /** @type {(inputs: Opened_StateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`เปิดแล้ว`)
};

const tr_opened_state = /** @type {(inputs: Opened_StateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Açıldı`)
};

const zh_cn_opened_state = /** @type {(inputs: Opened_StateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`已开启`)
};

const zh_tw_opened_state = /** @type {(inputs: Opened_StateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`已開啟`)
};

/**
* | output |
* | --- |
* | "Opened" |
*
* @param {Opened_StateInputs} inputs
* @param {{ locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }} options
* @returns {LocalizedString}
*/
export const opened_state = /** @type {((inputs?: Opened_StateInputs, options?: { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Opened_StateInputs, { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_opened_state(inputs)
	if (locale === "ar") return ar_opened_state(inputs)
	if (locale === "de") return de_opened_state(inputs)
	if (locale === "es") return es_opened_state(inputs)
	if (locale === "fr") return fr_opened_state(inputs)
	if (locale === "it") return it_opened_state(inputs)
	if (locale === "ja") return ja_opened_state(inputs)
	if (locale === "ko") return ko_opened_state(inputs)
	if (locale === "pt_br") return pt_br_opened_state(inputs)
	if (locale === "ru") return ru_opened_state(inputs)
	if (locale === "th") return th_opened_state(inputs)
	if (locale === "tr") return tr_opened_state(inputs)
	if (locale === "zh_cn") return zh_cn_opened_state(inputs)
	return zh_tw_opened_state(inputs)
});